import { useTraccUsagesQuery } from "@sso/apis/traccUsages";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectTraccUsageQuery } from "@sso/store/slices/traccUsage";

export const useGetTraccUsagesQuery = () => {
  const queryParams = useAppSelector(selectTraccUsageQuery);
  return useTraccUsagesQuery(queryParams);
};